/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {toAbsoluteUrl} from '../../../helpers'
import {useThemeMode} from '../theme-mode/ThemeModeProvider'
import {setAvatarDefault} from '../../../../app/utils/helperFunction/_helper'
import {useUserStateProvider} from '../../../../app/utils/contextProvider/UserStateProvider'

const UserMenu: FC = () => {
  const {currentUser, parentAuth, logout, logoutAsParent, isLogingAs} = useAuth()
  const {userAttachments} = useUserStateProvider()
  const {mode} = useThemeMode()
  const navigate = useNavigate()

  const handleAsLogin = () => {
    logoutAsParent()
    if (!isLogingAs) {
      navigate('/users/list')
    }
  }

  const onLogout = () => {
    logout()
  }

  return (
    <div className='menu menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'>
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-start px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt={currentUser?.username} src={setAvatarDefault(userAttachments.userprofile)} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.first_name} {currentUser?.first_name}
              <span className='fw-bolder fs-6 mb-1'>{currentUser?.username}</span>
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7 text-break'>
              {currentUser?.userEmail}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile/overview'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          <span className='menu-text'>My Projects</span>
          <span className='menu-badge'>
            <span className='badge badge-light-danger badge-circle fw-bolder fs-7'>3</span>
          </span>
        </a>
      </div>

      <div
        className='menu-item px-5'
        data-kt-menu-trigger='hover'
        data-kt-menu-placement='left-start'
        data-kt-menu-flip='bottom'
      >
        <a href='#' className='menu-link px-5'>
          <span className='menu-title'>My Subscription</span>
          <span className='menu-arrow'></span>
        </a>

        <div className='menu-sub menu-sub-dropdown w-175px py-4'>
          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Referrals
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Billing
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link px-5'>
              Payments
            </a>
          </div>

          <div className='menu-item px-3'>
            <a href='#' className='menu-link d-flex flex-stack px-5'>
              Statements
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='View your statements'
              ></i>
            </a>
          </div>

          <div className='separator my-2'></div>

          <div className='menu-item px-3'>
            <div className='menu-content px-3'>
              <label className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input w-30px h-20px'
                  type='checkbox'
                  value='1'
                  defaultChecked={true}
                  name='notifications'
                />
                <span className='form-check-label text-muted fs-7'>Notifications</span>
              </label>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className='menu-item px-5'>
        <a href='#' className='menu-link px-5'>
          My Statements
        </a>
      </div>

      <div className='separator my-2'></div> */}

      {/* <Languages /> */}

      <div className='menu-item px-5 my-1'>
        <Link to={'/account-settings'} className='menu-link px-5'>
          Account Settings
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a
          onClick={onLogout}
          className='menu-link px-5 d-block w-100 text-center bg-secondary text-dark'
        >
          Sign Out
        </a>

        {parentAuth && (
          <a
            onClick={handleAsLogin}
            className='mt-4 menu-link px-5 d-block w-100 text-center bg-primary text-light'
          >
            Sign Out As Parent
          </a>
        )}
      </div>
    </div>
  )
}

export {UserMenu}
